export default {
  en: {
    label: {
      one: '+1 user',
      other: '+%{count} users',
    },
  },
};
